// extracted by css-extract-rspack-plugin
export default {"badge":"EwgZDg","brand":"X04t2g","success":"o9Gdaq","warning":"KXsQUH","destructive":"tlKe1n","info":"zC0J17","positive":"Upk2Mh"};